import { Component } from '@angular/core';

@Component({
  selector: 'invoice',
  templateUrl: 'invoice.component.html',
})
export class InvoiceComponent {}
